import React from "react";

const CaretUp = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M7.406 15.422L6 14.016l6-6 6 6-1.406 1.406L12 10.828z" />
  </svg>
);

export default CaretUp;



// WEBPACK FOOTER //
// ./src/components/Icons/CaretUp.js